<template>
  <div class="user-container">
    <UserManager :modeSuper="supperAdmin" :companyUID="user_company" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserManager from './components/user-manager'
export default {
 components:{
   UserManager
 },
   computed:{
     ...mapGetters(['user_company']),
    supperAdmin(){
      return this.roleAuth([this.role.spadmin])
    }
  },
}
</script>

<style>

</style>